/* Kiomia - fisarmonica delle domande.

   Apre e chiude con l'altezza animata invece di far scattare il pannello:
   le risposte sono lunghe e lo scatto fa perdere il segno a chi legge.

   L'altezza si anima da zero a quella vera misurata al momento, insieme alla
   spaziatura interna: se animassimo solo l'altezza, il padding resterebbe li'
   e il pannello chiuso lascerebbe una striscia vuota.

   A fine corsa gli stili in riga vengono tolti, cosi' il pannello torna libero
   di crescere se il testo cambia (o se cambia la larghezza dello schermo).
{%- endcomment -%} */
(function(){
  var FERMO = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CURVA = 'cubic-bezier(.22,.61,.36,1)';
  var DURATA = 280;

  function pulisci(p){
    p.style.transition = '';
    p.style.height = '';
    p.style.paddingTop = '';
    p.style.paddingBottom = '';
    p.style.overflow = '';
  }

  function apri(p){
    p.hidden = false;
    if (FERMO) return;
    var st = getComputedStyle(p);
    var pt = st.paddingTop, pb = st.paddingBottom;
    var h = p.scrollHeight;
    pulisci(p);
    p.style.overflow = 'hidden';
    p.style.height = '0px';
    p.style.paddingTop = '0px';
    p.style.paddingBottom = '0px';
    void p.offsetHeight;
    p.style.transition = 'height ' + DURATA + 'ms ' + CURVA + ', padding ' + DURATA + 'ms ' + CURVA;
    p.style.height = h + 'px';
    p.style.paddingTop = pt;
    p.style.paddingBottom = pb;
    fine(p, function(){ pulisci(p); });
  }

  function chiudi(p){
    if (FERMO){ p.hidden = true; return; }
    var h = p.scrollHeight;
    p.style.overflow = 'hidden';
    p.style.height = h + 'px';
    void p.offsetHeight;
    p.style.transition = 'height ' + DURATA + 'ms ' + CURVA + ', padding ' + DURATA + 'ms ' + CURVA;
    p.style.height = '0px';
    p.style.paddingTop = '0px';
    p.style.paddingBottom = '0px';
    fine(p, function(){ p.hidden = true; pulisci(p); });
  }

  /* Un solo ascoltatore per volta, e una rete di sicurezza se la transizione
     non arriva mai (succede se il pannello viene nascosto a meta' strada). */
  function fine(p, cosa){
    if (p._kmFine){ p.removeEventListener('transitionend', p._kmFine); clearTimeout(p._kmTimer); }
    p._kmFine = function(e){
      if (e.target !== p || e.propertyName !== 'height') return;
      p.removeEventListener('transitionend', p._kmFine);
      clearTimeout(p._kmTimer);
      p._kmFine = null;
      cosa();
    };
    p.addEventListener('transitionend', p._kmFine);
    p._kmTimer = setTimeout(function(){
      if (p._kmFine){ p.removeEventListener('transitionend', p._kmFine); p._kmFine = null; cosa(); }
    }, DURATA + 120);
  }

  function init(root){
    (root || document).querySelectorAll('[data-km-faq]:not([data-km-ready])').forEach(function(acc){
      acc.setAttribute('data-km-ready', '1');
      acc.querySelectorAll('[data-km-faq-btn]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var item = btn.closest('[data-km-faq-item]');
          var panel = item.querySelector('[data-km-faq-panel]');
          var aperto = btn.getAttribute('aria-expanded') === 'true';

          if (acc.getAttribute('data-km-single') === 'true'){
            acc.querySelectorAll('[data-km-faq-btn]').forEach(function(b){
              if (b === btn) return;
              if (b.getAttribute('aria-expanded') !== 'true') return;
              b.setAttribute('aria-expanded', 'false');
              var p = b.closest('[data-km-faq-item]').querySelector('[data-km-faq-panel]');
              if (p) chiudi(p);
              var s = b.querySelector('[data-km-faq-sign]');
              if (s) s.textContent = '+';
            });
          }

          btn.setAttribute('aria-expanded', String(!aperto));
          if (panel){ if (aperto) chiudi(panel); else apri(panel); }
          var sign = btn.querySelector('[data-km-faq-sign]');
          if (sign) sign.textContent = aperto ? '+' : '–';
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:section:select', function(e){ init(e.target); });
})();
